<template>
  <svg
    v-if="!isRead"
    t="1647793631491"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4876"
    width="30"
    height="30"
  >
    <path
      d="M955.666682 268.427542c1.858324-8.362458 1.161453-16.957207-4.644787-23.693632-0.930185-1.160429-2.787486-0.929162-3.948938-2.090614-9.756201-22.532179-26.945699-38.09462-59.23408-38.09462H163.088402c-34.378995 0-71.777767 13.240559-88.270393 39.024805-0.696872 0.463558-1.626034 0.463558-2.322905 1.160429-6.039553 6.736425-6.968715 15.331173-5.342681 23.461342-0.232291 2.090615-1.626034 3.716648-1.626034 6.039553v445.99982c0 45.99352 51.336202 97.562013 97.562013 97.562013h724.749452c46.225811 0 69.919443-51.568493 69.919443-97.562013V274.235828c0-2.555196-1.857301-3.484358-2.090615-5.808286z m-81.766258-8.129144h14.16972L511.525186 560.418756l-375.151216-298.958906c8.594749-1.393743 19.047822-1.160429 26.713409-1.160429h710.813045v-0.001023z m13.93743 501.749541H163.088402c-15.331173 0-41.812291-26.481118-41.812291-41.812291V320.92622l372.131439 297.565163c5.110391 4.644787 11.614525 6.735401 18.118659 6.735401s13.008268-2.322905 18.35095-6.735401L902.007575 320.92622v399.540695c0 15.099906 1.161453 41.581024-14.169721 41.581024z"
      p-id="4877"
      fill="#0277BD"
    />
  </svg>
  <svg
    v-else
    t="1647793722403"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="5194"
    width="30"
    height="30"
  >
    <path
      d="M65.201965 1014.976018a56.214967 56.214967 0 0 1-56.177983-56.067032v-478.197053a55.956082 55.956082 0 0 1 25.407685-46.784166l165.353366-165.131465 0.776654-109.027449a24.261196 24.261196 0 0 1 24.224213-24.187229h107.252239L451.199075 34.283733a90.535683 90.535683 0 0 1 125.004334-0.443802l118.347299 101.112973 104.515458 0.62872a24.224213 24.224213 0 0 1 24.224213 24.187229v105.144178l169.014735 171.270731a60.209188 60.209188 0 0 1 10.651257 10.651257 55.475296 55.475296 0 0 1 11.83473 33.876914v478.160069a56.177983 56.177983 0 0 1-56.141 56.067033H65.201965z m443.802369-418.690551a46.155446 46.155446 0 0 0-29.586825 10.577289l-139.538861 129.442358a44.713089 44.713089 0 0 1-3.106617 5.214678 24.224213 24.224213 0 0 1-9.023981 6.213233l-236.176828 218.831552h844.703843l-397.609939-360.367524a48.929211 48.929211 0 0 0-29.586825-9.94857zM57.583357 932.169893L281.074834 724.766253l-223.491477-197.085236v404.451893z m688.670327-203.076567l220.273909 199.711066V533.635366z m-236.694597-180.9974a97.266686 97.266686 0 0 1 60.02427 20.821728l140.537417 127.408263 63.981509-56.658769 0.850621-455.563132H249.047096v446.613118l67.753829 60.948858 131.25455-121.749783a96.7859 96.7859 0 0 1 61.392661-21.857266z m314.02716 47.671771l138.429355-122.822305-51.592025-52.553598-7.840509-8.765097-78.922854-79.033805v263.174805zM101.112973 436.146778l-2.182028 1.035539-33.544063 32.693441 135.211789 119.345854V336.698064l-99.485698 99.448714zM514.071078 56.584802a39.38746 39.38746 0 0 0-27.95955 11.575845l-79.995377 67.494944h216.057787l-80.587113-67.901763a38.906674 38.906674 0 0 0-27.515747-11.095059z m0 0"
      p-id="5195"
      fill="grey"
    />
  </svg>
</template>

<script>

export default {
  name: 'MMessage',
  props: {
    isRead: {}
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
